<template>
    <el-card v-if="visible" class="w-[400px]" ref="targetRef" v-loading="loading">
        <template slot="header">
            <span>消息列表</span>
        </template>
        <el-empty v-if="list.length == 0 && !loading" image-style="height: 100px" description="暂无数据"></el-empty>
        <el-scrollbar v-else style="height: 300px;">
            <div :data="list" v-for="(item, index) in list" :key="`msg-${item.id}`">
                <el-divider v-if="index > 0"></el-divider>
                <div class="text-sm text-gray-500">{{ dayjs(item.addtime * 1000).format('YYYY-MM-DD HH:mm:ss') }}
                </div>
                <div class="text-xs text-gray-500 mt-[10px] line-clamp-4" :title="item.desc">
                    {{ item.desc }}
                </div>
            </div>
        </el-scrollbar>
        <el-pagination v-if="total > 0" :small="true" :current-page.sync="page" layout="total, prev, pager, next"
            :total="total" @current-change="onCurrentChange" />
    </el-card>
</template>
<script>
import { post } from "@/assets/js/http.js"
import dayjs from "dayjs";
export default {
    data() {
        return {
            dayjs,
            visible: false,
            loading: false,
            page: 1,
            list: [],
            total: 0
        }
    },
    methods: {
        onCurrentChange(page) {
            this.page = page
            this.getList()
        },
        open() {
            this.visible = true;
            document.addEventListener('click', this.handleClickOutside);
            this.page = 1
            this.getList()
        },
        getList() {
            this.loading = true
            post({
                url: "/admin/employees.Employees/userMessage",
                data: {
                    page: this.page,
                    pageSize: 10
                }
            }).then(res => {
                this.list = res.list
                this.total = res.total
            }).finally(() => {
                this.loading = false
            })
        },
        doSomething() { console.log('内部操作'); },
        // 点击遮罩层直接关闭（可选）
        handleMaskClick() { this.visible = false; },
        // 全局点击判断
        handleClickOutside(e) {
            this.$nextTick(() => {
                // 1. 仅在组件显示时执行判断
                if (!this.visible) return;

                // 2. 通过 ref 获取组件 DOM 节点
                const targetEl = this.$refs.targetRef.$el;

                // 3. 判断点击目标是否在组件内部（包含组件自身）
                const isInside = targetEl && targetEl.contains(e.target);

                // 4. 若在外部，执行关闭逻辑
                if (!isInside) {
                    this.visible = false; // 关闭组件
                    // 可添加其他逻辑：如触发回调、清除定时器等
                }

            })
        }
    }
}
</script>